import {Injectable} from '@angular/core';
import * as _ from 'lodash-es';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {AssetType} from '../../../enums/asset-type';
import {formatSecurityKey, parseSecurityKey} from '../../../models/security-key';
import {AppConfigService} from '../../../services/config.service';
import {OrderDetailsWidgetSettings, OrderDetailsWidgetSettingsDef} from './order-details-widget-settings';

@Injectable()
export class OrderDetailsWidgetSettingsService implements WidgetSettingsService {

    private readonly defaultSettingsDef: OrderDetailsWidgetSettingsDef = {
        title:          undefined,
        accountId:      undefined,
        clOrdId:        undefined,
        securityKeyStr: this.appConfigService.appConfig.defaultSecurityKey,
        quantity:       undefined,
        limitPrice:     undefined,
        stopPrice:      undefined,
        twapTimeRange:  [undefined, undefined]
    };

    constructor(
        private appConfigService: AppConfigService
    ) {}

    public getDefaultSettings(): Observable<OrderDetailsWidgetSettings> {
        return this.fromDefinition(this.defaultSettingsDef);
    }

    public fromDefinition(
        settingsDef: OrderDetailsWidgetSettingsDef
    ): Observable<OrderDetailsWidgetSettings> {
        const securityKey = parseSecurityKey(settingsDef.securityKeyStr
            || this.defaultSettingsDef.securityKeyStr);

        const twapTimeRangeDef = settingsDef.twapTimeRange || this.defaultSettingsDef.twapTimeRange;
        const settings: OrderDetailsWidgetSettings = {
            title:        null,
            accountId:    settingsDef.accountId,
            clOrdId:      settingsDef.clOrdId,
            securityKey,
            quantity:     settingsDef.quantity,
            limitPrice:   settingsDef.limitPrice,
            stopPrice:    settingsDef.stopPrice,
            qtyAssetType: AssetType[settingsDef.qtyAssetType] || undefined,
            order:        settingsDef.order,

            twapTimeRange:     [...twapTimeRangeDef] as [number, number],
            twapStepDelay:     _.defaultTo(settingsDef.twapStepDelay, this.defaultSettingsDef.twapStepDelay),
            twapRandomQty:     _.defaultTo(settingsDef.twapRandomQty, this.defaultSettingsDef.twapRandomQty),
            twapRandomTime:    _.defaultTo(settingsDef.twapRandomTime, this.defaultSettingsDef.twapRandomTime),
            twapStepDelayUnit: 1,
            sniperDelay:       _.defaultTo(settingsDef.sniperDelay, this.defaultSettingsDef.sniperDelay),
            sniperDelayUnit:   1
        };

        return of(settings);
    }

    public toDefinition(settings: OrderDetailsWidgetSettings): OrderDetailsWidgetSettingsDef {
        return settings && {
            title:          null,
            accountId:      settings.accountId,
            clOrdId:        settings.clOrdId,
            securityKeyStr: formatSecurityKey(settings.securityKey),
            quantity:       settings.quantity,
            limitPrice:     settings.limitPrice,
            stopPrice:      settings.stopPrice,
            qtyAssetType:   settings.qtyAssetType,

            twapTimeRange:  settings.twapTimeRange ? [...settings.twapTimeRange] as [number, number] : undefined,
            twapStepDelay:  settings.twapStepDelay,
            twapRandomQty:  settings.twapRandomQty,
            twapRandomTime: settings.twapRandomTime,
            sniperDelay:    settings.sniperDelay
        };
    }

}
